<template>
  <div v-if="task">
    <task-body :task="task" :try-join="tryJoin" :try-leave="tryLeave" />
    <box class="pb-4">
      <h3 class="mb-5">{{ $tc('reward', 2) }}</h3>
      <div class="mb-1">
        <masonry :cols="{ default: 3, 1200: 2, 992: 1 }" :gutter="20">
          <reward
            class="mb-4"
            :title="task.subTasks.subscribe.title"
            icon="subscribe"
            :prices="task.subTasks.subscribe.prices"
          />
          <reward
            class="mb-4"
            :title="task.subTasks.post.title"
            :metric-title="task.subTasks.post.metricTitle"
            icon="post"
            :daily-limit="task.subTasks.post.dailyLimit"
            :weekly-limit="task.subTasks.post.dailyLimit"
            :prices="task.subTasks.post.prices"
          />
          <reward
            class="mb-4"
            :title="task.subTasks.comment.title"
            :metric-title="task.subTasks.comment.metricTitle"
            icon="comment-o"
            :daily-limit="task.subTasks.comment.dailyLimit"
            :weekly-limit="task.subTasks.comment.dailyLimit"
            :prices="task.subTasks.comment.prices"
          />
          <reward
            class="mb-4"
            :title="task.subTasks.follow.title"
            icon="follow"
            :prices="task.subTasks.follow.prices"
          />
        </masonry>
      </div>
    </box>
  </div>
</template>

<script>
import taskMixin from './../../mixins/task.js';

export default {
  mixins: [taskMixin]
};
</script>
